export type CardData = {
  userEmail: string
  userFullName: string
  nickName: string
  currency: string
  limits: {
    amount?: number
    interval?: string
    intervalRank?: number // Front end only to check an amount of an interval is not larger than another amount of an interval that is higher
  }[]
}

export const DEFAULT_CARD_DATA: CardData = {
  userEmail: '',
  userFullName: '',
  nickName: '',
  currency: '',
  limits: [{ amount: undefined, interval: undefined, intervalRank: undefined }],
}
